import { render, staticRenderFns } from "./d-profile-badge.vue?vue&type=template&id=37472b65&scoped=true&"
import script from "./d-profile-badge.vue?vue&type=script&lang=js&"
export * from "./d-profile-badge.vue?vue&type=script&lang=js&"
import style0 from "./d-profile-badge.vue?vue&type=style&index=0&id=37472b65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37472b65",
  null
  
)

export default component.exports